import { Box, ColorOptions, Loader, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import { FC, useEffect, useRef, useState } from 'react'
import { Dimensions, FlatList, InteractionManager } from 'react-native'
import { useKeyboard } from '../../../comps/KeyboardAwareModal/keyboardHook'
import { SvgImage } from '../../../comps/SvgImage'
import { TextInputWithLabelOnBorder } from '../../../comps/TextInputWithLabelOnBorder'
import { useLazyApiData, useStores } from '../../../data/store'
import { Colors } from '../../../util/util'
import { SearchBar } from '../SearchBar'
import styles from './styles'

const height = Dimensions.get('screen').height

const EducationFee: FC = ({ ...props }: any) => {
  const [showModal, setShowModal] = useState(false)
  const inputRef = useRef(null)
  const isFocused = useIsFocused()
  const [keyboardHeight] = useKeyboard()
  const { getLocationList, locationInfo } = useStores((root) => ({
    getLocationList: root.billPayments.getLocationListApi,
    locationInfo: root.billPayments.transaction.locationInfo,
  }))

  const [getLocationListApi, { state: locationState }] = useLazyApiData(getLocationList)
  const [searchText, setSearchText] = useState('')

  const states = ((list) => {
    const parsed = JSON.parse(JSON.stringify(list))
    return parsed?.map((item) => {
      return { title: item.name, id: item.id }
    })
  })(locationInfo.state)

  const getStates = (searchText: string) => {
    if (searchText !== '') {
      const filteredState = states?.filter((item) => {
        return item?.title?.toLowerCase().includes(searchText?.toLowerCase())
      })
      return filteredState ?? []
    } else {
      return states
    }
  }

  useEffect(() => {
    getLocationListApi()
    if (isFocused) {
      InteractionManager.runAfterInteractions(() => {
        if (inputRef?.current && !inputRef?.current?.isFocused()) {
          inputRef?.current?.focus()
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChangeText = (text: string) => {
    setSearchText(text)
  }

  const selectState = async (state: any) => {
    const { setFieldValue, fieldName } = props
    setFieldValue(fieldName, state.title)
    showHideModal(false)
    //navigation.navigate(Routes.SELECT_CITY as never, { state: state.title } as never)
  }

  const renderItem = ({ item }: any) => {
    return (
      <Box
        key={item?.id}
        underlayColor={'TRANSPARENT'}
        testID={'state-' + item?.title?.replaceAll(' ', '')}
        onPress={() => selectState(item)}
        justifyContent={'center'}
        width="100%">
        <Box pv={12} width={'100%'}>
          <Text testID="title" {...styles.title}>
            {item?.title}
          </Text>
        </Box>
      </Box>
    )
  }

  const onEndReached = () => {
    console.log('********* onEndReached: ' + Math.ceil(locationInfo.state?.length / 20))
  }

  const showHideModal = (value) => {
    setShowModal(value)
  }

  return (
    <Box>
      <Box>
        <TextInputWithLabelOnBorder
          editable={false}
          onPressIn={() => showHideModal(true)}
          onPress={() => showHideModal(true)}
          innerRef={inputRef}
          {...props}
        />
      </Box>

      <ModalDialogNew type={'bottom'} animate={true} show={showModal} backgroundColor="TRANSPARENT">
        <Box
          height={keyboardHeight === 0 ? height - 140 : height - 140 - keyboardHeight}
          borderTopLeftRadius={24}
          borderTopRightRadius={24}
          backgroundColor="WHITE"
          ph={25}>
          <ModBox f={1} justify="center" align="center" show={locationState === 'pending'}>
            <Loader />
            <Spacer size={10} direction="vertical" />
            <Text color={Colors.BLACK_14 as ColorOptions} fontFamily="JioType-Medium" fontSize={14}>
              Loading...
            </Text>
          </ModBox>
          <ModBox flex={1} show={locationState !== 'pending'} backgroundColor="WHITE">
            <Spacer size={32} direction="vertical" />
            <Box flexDirection={'row'} justifyContent="space-between" align="center">
              <Text color={Colors.BLACK_14 as ColorOptions} fontFamily="JioType-Black" fontSize={24} lineHeight={28}>
                {props?.placeholder}
              </Text>
              <Box
                onPress={() => {
                  showHideModal(false)
                }}
                testID="close-edu-modal"
                underlayColor={'TRANSPARENT'}>
                <SvgImage imageName="Close" />
              </Box>
            </Box>

            <Box paddingTop={24} paddingBottom={8} width={'100%'}>
              <SearchBar
                onChange={onChangeText}
                value={searchText}
                placeholder="Search State"
                borderRadius={8}
                theme={{ bodyBgColor: '#fff', bodyTextColor: '#B5B5B5' as ColorOptions }}
              />
            </Box>

            <FlatList
              horizontal={false}
              contentContainerStyle={{ width: '100%', alignItems: 'stretch' }}
              renderItem={renderItem}
              data={getStates(searchText)}
              onEndReached={onEndReached}
              keyExtractor={(item) => item.id}
              style={{ width: '100%' }}
            />
          </ModBox>
        </Box>
      </ModalDialogNew>
    </Box>
  )
}

export { EducationFee }
